import React, { useEffect, useRef } from 'react';
import { FormikHelpers } from 'formik';
import { Card, LinearProgress } from '@material-ui/core';
import { Event as EventIcon } from '@material-ui/icons';

import CardTitle from '../../../common/card/CardTitle';
import CardContent from '../../../common/card/CardContent';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineDatePicker from '../../../common/inline/InlineDatePicker';
import { useUpdateTask } from '../Task.hooks';
import { BaseTaskCardProps, Task } from '../Task.interface';

export interface TaskDueDateCardProps extends BaseTaskCardProps {
  disabled?: boolean;
}

const TaskDueDateCard: React.FC<TaskDueDateCardProps> = (
  props: TaskDueDateCardProps
) => {
  const { task, disabled = false, onChange, onError } = props;
  const formikRef = useRef<FormikHelpers<Partial<Task>>>();
  const {
    updatedTask,
    isUpdating: isLoading,
    updateError: error,
    updateTask
  } = useUpdateTask(task.id || 0);

  useEffect(() => {
    if (updatedTask) {
      onChange?.(updatedTask);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedTask]);

  useEffect(() => {
    if (error) {
      onError?.(error);
      // reset field back to initial value
      formikRef.current?.setFieldValue('dueDate', task.dueDate || null, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <Card>
      {isLoading && <LinearProgress />}
      <CardTitle>
        <EventIcon />
        Due Date
      </CardTitle>
      <CardContent>
        <InlineFormik
          strict={false}
          enableReinitialize
          innerRef={(formik: any) => (formikRef.current = formik)}
          initialValues={{ dueDate: task.dueDate || null }}
          onSubmit={(values: Partial<Task>) => {
            values = { ...values, dueDate: values.dueDate || null };
            updateTask(values);
          }}
        >
          <InlineForm autoComplete='off'>
            <InlineDatePicker
              clearable={!disabled}
              asInnerLabel
              name='dueDate'
              label='Due Date'
              setDateHours={true}
              disabled={disabled}
              autoCloseOnSelect={true}
            />
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default TaskDueDateCard;
